import { frontendURL } from '../../../helper/URLHelper';

const CalendarView = () => import('./pages/CalendarView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    name: 'crm_calendar',
    meta: { permissions: ['administrator', 'agent'] },
    component: CalendarView,
  },
];
